import { createSelector } from 'reselect'
import presentationOriginTypes from 'helpers/enums/presentationOriginTypes'
import activityOriginSelector from 'redux/selectors/activity_creation/activity_origin_selector'

const oeqSelector = state => state.oeq

const saveSelector = createSelector(
	[oeqSelector, activityOriginSelector],
	(oeq, activityOrigin) => ({
		entityUID: oeq.entityUID,
		allIconsDone: oeq.questions.filter(question => question.icon.status === 'uploading').length === 0,
		allQuestionsDone: oeq.questions.filter(question => question.status === 'saving' || question.status === 'deleting' || question.status === 'changed').length === 0,
		studentRecordingAudioEnabled: oeq.studentRecordingAudioEnabled,
		allowPublishWithoutThumbnail: activityOrigin === presentationOriginTypes.QUICK_LAUNCH,
	})
)

export default saveSelector
